export default __webpack_public_path__ + "locales/bg/InviteDialog.json?hash=b41dd10fc75d7b86308fe8d8ab9c011c";